import { render, staticRenderFns } from "./coWithdrawList.vue?vue&type=template&id=07580df8&scoped=true"
import script from "./coWithdrawList.vue?vue&type=script&lang=js"
export * from "./coWithdrawList.vue?vue&type=script&lang=js"
import style0 from "./coWithdrawList.vue?vue&type=style&index=0&id=07580df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07580df8",
  null
  
)

export default component.exports